module.exports = __webpack_public_path__ + "static/Water_Saving_System_s-a31923816167b8284d5b4341127debb3.png";